import { Icon } from "@beresta/ui";
import { t } from "../i18n.js";
import { TABS, type Tab } from "./places.js";

/**
 * Нижня панель на пʼять місць (картка TabBar). Вибране місце — лаймова
 * пігулка 40×30 під іконкою, і підпис темнішає: два сигнали, жоден не на
 * самому кольорі. «Писати» — єдина суцільна вкладка: вона не веде на
 * сторінку, а відкриває шторку B1 поверх поточного екрана.
 *
 * Лічильників панель не показує — ні серій, ні невиконаного.
 */
export interface TabBarProps {
  readonly current: Tab;
  readonly onTab: (tab: Tab) => void;
  readonly onWrite: () => void;
}

export function TabBar({ current, onTab, onWrite }: TabBarProps) {
  return (
    <div className="bar-wrap">
      <nav className="bar" aria-label={t("nav.tabs")}>
        {TABS.map(({ tab, label, icon }) =>
          tab === "write" ? (
            <button key={tab} type="button" className="tab tab-write" onClick={onWrite}>
              <span className="ic">
                <Icon name={icon} />
              </span>
              <span className="caption-1">{t(label)}</span>
            </button>
          ) : (
            <button
              key={tab}
              type="button"
              className="tab"
              aria-current={current === tab ? "page" : undefined}
              onClick={() => onTab(tab)}
            >
              <span className="ic">
                <Icon name={icon} />
              </span>
              <span className="caption-1">{t(label)}</span>
            </button>
          ),
        )}
      </nav>
    </div>
  );
}
